import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notice the disconnection",
    opening: localizedGenderNode(
      [
      "Today I don't try to fix it.",
      "I just notice the disconnection as it is.",
      "That is enough for now."
    ],
      [
      "Today I don't try to fix it.",
      "I just notice the disconnection as it is.",
      "That is enough for now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I feel the disconnection most?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ],
      [
      "When do I feel the disconnection most?",
      "What is happening around me then?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing disconnection is already a gentle connection."
    ],
      [
      "Noticing disconnection is already a gentle connection."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the words \"I am here\".",
      "one breath with the words \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What is missing there",
    opening: localizedGenderNode(
      [
      "Today I ask what I miss in this connection.",
      "Not to blame.",
      "Just to identify."
    ],
      [
      "Today I ask what I miss in this connection.",
      "Not to blame.",
      "Just to identify."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my chest."
    ],
      [
      "I breathe slowly.",
      "I feel my chest."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I miss from my family or children?",
      "What would I want them to see in me?",
      "What is hard for me to ask for?"
    ],
      [
      "What do I miss from my family or children?",
      "What would I want them to see in me?",
      "What is hard for me to ask for?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small lack can explain a lot."
    ],
      [
      "A small lack can explain a lot."
    ]
    ),
    action: localizedGenderNode(
      "write one word about what is missing.",
      "write one word about what is missing."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "What changed between us",
    opening: localizedGenderNode(
      [
      "Today I look at the change.",
      "Without judgment.",
      "Just to see."
    ],
      [
      "Today I look at the change.",
      "Without judgment.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What has changed recently?",
      "What was there before that is missing now?",
      "What do I miss?"
    ],
      [
      "What has changed recently?",
      "What was there before that is missing now?",
      "What do I miss?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Longing is a sign there was connection."
    ],
      [
      "Longing is a sign there was connection."
    ]
    ),
    action: localizedGenderNode(
      "remember one good moment.",
      "remember one good moment."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "What I keep inside",
    opening: localizedGenderNode(
      [
      "Today I check what I hold inside.",
      "Not to release.",
      "Just to see."
    ],
      [
      "Today I check what I hold inside.",
      "Not to release.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my belly."
    ],
      [
      "I breathe slowly.",
      "I feel my belly."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I not say to them?",
      "Why do I stay silent about it?",
      "What am I afraid will happen if I say it?"
    ],
      [
      "What do I not say to them?",
      "Why do I stay silent about it?",
      "What am I afraid will happen if I say it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Silence sometimes protects."
    ],
      [
      "Silence sometimes protects."
    ]
    ),
    action: localizedGenderNode(
      "write one sentence I did not say.",
      "write one sentence I did not say."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The fear under the disconnection",
    opening: localizedGenderNode(
      [
      "Today I ask what scares me about closeness.",
      "Not to fight.",
      "Just to know."
    ],
      [
      "Today I ask what scares me about closeness.",
      "Not to fight.",
      "Just to know."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid will happen if I get closer?",
      "What am I trying to protect?",
      "How does this fear protect me?"
    ],
      [
      "What am I afraid will happen if I get closer?",
      "What am I trying to protect?",
      "How does this fear protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear is also a sign of wanting connection."
    ],
      [
      "Fear is also a sign of wanting connection."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I see you\".",
      "tell myself \"I see you\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "A small moment of connection",
    opening: localizedGenderNode(
      [
      "Today I look for a small moment of connection.",
      "Not big.",
      "Small is enough."
    ],
      [
      "Today I look for a small moment of connection.",
      "Not big.",
      "Small is enough."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When was there a small moment of connection?",
      "What allowed it?",
      "How can I invite another moment like that?"
    ],
      [
      "When was there a small moment of connection?",
      "What allowed it?",
      "How can I invite another moment like that?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small moment changes the feeling."
    ],
      [
      "A small moment changes the feeling."
    ]
    ),
    action: localizedGenderNode(
      "remember one such moment.",
      "remember one such moment."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Staying one more moment",
    opening: localizedGenderNode(
      [
      "Today I practice staying one more moment in connection.",
      "Not running too fast.",
      "Just a moment."
    ],
      [
      "Today I practice staying one more moment in connection.",
      "Not running too fast.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I pull back too fast?",
      "What scares me if I stay?",
      "What happens if I stay 10 more seconds?"
    ],
      [
      "When do I pull back too fast?",
      "What scares me if I stay?",
      "What happens if I stay 10 more seconds?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One more moment can change something."
    ],
      [
      "One more moment can change something."
    ]
    ),
    action: localizedGenderNode(
      "pause 10 seconds before I pull back.",
      "pause 10 seconds before I pull back."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "One gentle word",
    opening: localizedGenderNode(
      [
      "Today I check one gentle word I can bring.",
      "Not much.",
      "One word."
    ],
      [
      "Today I check one gentle word I can bring.",
      "Not much.",
      "One word."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my heart."
    ],
      [
      "I breathe slowly.",
      "I feel my heart."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What gentle word would I like to say?",
      "Who would I like to say it to?",
      "How does it feel to say it?"
    ],
      [
      "What gentle word would I like to say?",
      "Who would I like to say it to?",
      "How does it feel to say it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One word can open a heart."
    ],
      [
      "One word can open a heart."
    ]
    ),
    action: localizedGenderNode(
      "write one gentle word.",
      "write one gentle word."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "One request",
    opening: localizedGenderNode(
      [
      "Today I form one small request.",
      "Not a demand.",
      "A request."
    ],
      [
      "Today I form one small request.",
      "Not a demand.",
      "A request."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What would I like to ask for gently?",
      "How can I say it softly?",
      "What is a small step toward it?"
    ],
      [
      "What would I like to ask for gently?",
      "How can I say it softly?",
      "What is a small step toward it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One request can shift the pace."
    ],
      [
      "One request can shift the pace."
    ]
    ),
    action: localizedGenderNode(
      "write the request in one sentence.",
      "write the request in one sentence."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Seeing the other side",
    opening: localizedGenderNode(
      [
      "Today I try to see the other side too.",
      "Not to justify.",
      "Just to see."
    ],
      [
      "Today I try to see the other side too.",
      "Not to justify.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I am here."
    ],
      [
      "I breathe slowly.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What might be hard for them too?",
      "What might they be afraid to lose?",
      "What changes in me when I see that?"
    ],
      [
      "What might be hard for them too?",
      "What might they be afraid to lose?",
      "What changes in me when I see that?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A wider view can soften pain."
    ],
      [
      "A wider view can soften pain."
    ]
    ),
    action: localizedGenderNode(
      "write one word of softness toward them.",
      "write one word of softness toward them."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "The value that holds us",
    opening: localizedGenderNode(
      [
      "Today I look for one value that holds the connection.",
      "Small.",
      "But true."
    ],
      [
      "Today I look for one value that holds the connection.",
      "Small.",
      "But true."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Which value matters to me in family?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ],
      [
      "Which value matters to me in family?",
      "How does that value look on an ordinary day?",
      "What small step could honor it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "One value can be a thread of connection."
    ],
      [
      "One value can be a thread of connection."
    ]
    ),
    action: localizedGenderNode(
      "one word that expresses the value.",
      "one word that expresses the value."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Returning to myself inside the bond",
    opening: localizedGenderNode(
      [
      "Today I check how to return to myself inside the family.",
      "Not to run away.",
      "Just to return."
    ],
      [
      "Today I check how to return to myself inside the family.",
      "Not to run away.",
      "Just to return."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my feet."
    ],
      [
      "I breathe slowly.",
      "I feel my feet."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What brings me back to myself in this bond?",
      "What takes me away from myself?",
      "What could help me return?"
    ],
      [
      "What brings me back to myself in this bond?",
      "What takes me away from myself?",
      "What could help me return?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Returning to myself is also connection."
    ],
      [
      "Returning to myself is also connection."
    ]
    ),
    action: localizedGenderNode(
      "one breath when I am with family.",
      "one breath when I am with family."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A small step of closeness",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of closeness.",
      "No drama.",
      "A small step."
    ],
      [
      "Today I choose a small step of closeness.",
      "No drama.",
      "A small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ],
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step is enough to move."
    ],
      [
      "A small step is enough to move."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a sentence that brings me back to closeness.",
      "When I feel far.",
      "A small sentence."
    ],
      [
      "Today I choose a sentence that brings me back to closeness.",
      "When I feel far.",
      "A small sentence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this disconnection?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ],
      [
      "What did I learn about this disconnection?",
      "What is the first sign it returns?",
      "Which sentence brings me back a moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can feel far and still stay with myself."
    ],
      [
      "I can feel far and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "say the new sentence once.",
      "say the new sentence once."
    ),
  },
].map(buildNormalizedDay);

export const feelingDisconnectedFromTheFamilyChildrenBlueprintEn = buildNormalizedPilotBlueprint({
  id: "feeling_disconnected_from_the_family_children_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "feeling_disconnected_from_the_family_children",
  category: "loneliness_belonging",
  journeyName: {
    he: "תחושת נתק מהמשפחה / מהילדים",
    en: "Feeling disconnected from the family / children",
    es: "Sensación de desconexión de la familia / de los hijos",
  },
  days,
});

export default feelingDisconnectedFromTheFamilyChildrenBlueprintEn;
